module.exports = __webpack_public_path__ + "fonts/Lato-Thin.7ab0bc06.ttf";